import { twMerge } from 'tailwind-merge';
import { clsx } from 'clsx';
import { ImgHTMLAttributes, ReactNode, useState } from 'react';

export const ImageLoader = ({
  src,
  alt,
  className,
  id,
  isWithFallback = true,
  fallback = null,
  ...props
}: Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  isWithFallback?: boolean;
  fallback?: ReactNode;
  src?: string | null;
}) => {
  const [hasError, setHasError] = useState(!Boolean(src));

  if (hasError) {
    return isWithFallback
      ? fallback || (
          <div
            className="flex size-[32px] min-w-[32px] items-center rounded-sm bg-[#ECF2FF] sm:size-[56px]"
            data-testid={`${id}-default-logo`}
          >
            <span className="w-full text-center text-[20px] !font-normal text-general-100 sm:text-[30px]">
              ?
            </span>
          </div>
        )
      : null;
  }

  return (
    <img
      className={twMerge(clsx('size-auto max-w-full', className))}
      alt={alt}
      src={src || ''}
      onError={() => setHasError(true)}
      data-testid={`${id}-logo`}
      id={id}
      {...props}
    />
  );
};
